import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import PdfViewerDialog from 'components/ReusableComponents/PdfViewerDialog'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import invoiceApi from 'services/api/invoices'

import styles from './InvoiceAsPDF.module.scss'

const InvoiceAsPDF = () => {
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [invoiceURL, setInvoiceURL] = useState()
  const [invoiceDownloadURL, setInvoiceDownloadURL] = useState()
  const history = useHistory()

  const { ids } = useParams()

  useEffect(() => {
    invoiceApi
      .getInvoicePdf({ invoiceId: ids })
      .then(res => {
        setInvoiceURL(res.tempPublicPath)
        setInvoiceDownloadURL(res.tempDownloadablePublicPath)
        setIsLoading(false)
        setError(null)
      })
      .catch(err => {
        setError(err)
      })
  }, [ids])

  return (
    <div className={styles.invoiceWrapper}>
      {error && <span>Invoice not found!</span>}
      {isLoading && <LoadingIndicator longWaitingTreshold={120} />}
      {!error && !isLoading && invoiceURL && (
        <div id="printArea" className={styles.printArea}>
          <PdfViewerDialog
            pdfUrl={invoiceURL}
            downloadUrl={invoiceDownloadURL}
            onClose={() => history.push('/billing')}
            title={`Invoice #${ids}`}
          />
        </div>
      )}
    </div>
  )
}

export default InvoiceAsPDF
